import React from "react";
import { Accordion } from "../../../../../../react-core/Html/Accordion";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { Email } from "../../../../../../react-core/Html/Validation/RegExPatterns";
import { EmailFrequency } from "../../../../../../Wrap/Constants/Enums/Notification/EmailFrequency";
import { NotificationEmailConfiguration } from "../../../../../../Wrap/Models/Domains/Threads/NotificationEmailConfiguration";
import { ValidatorContents } from "../../../../Common/ValidatorHelper";
import { UserStore } from "../../../../Stroes/Variable";
import { NotificationAction } from "../../Action/NotificationAction";
import { EmailFrequencyMap, EmailFrequencyOptions } from "../../Resource/Content";

interface IEmailNotificationProps {
    emailConfig: NotificationEmailConfiguration;
    onSave: () => void;
}

interface IEmailNotificationState {
    emailConfig: NotificationEmailConfiguration;
    emailAddress: string;
}

export class EmailNotification extends FormComponent<IEmailNotificationProps, IEmailNotificationState> {
    constructor(props: any) {
        super(props);
        this.state = {
            emailConfig: props.emailConfig,
            emailAddress: UserStore.getUserInfo()?.EmailAddress,
        };
    }

    componentDidMount() {}

    private onSave() {
        if (this.isValid()) {
            NotificationAction.updateNotificationEmailConfiguration(
                this.state.emailConfig,
                (result: NotificationEmailConfiguration) => {
                    this.setState({ emailConfig: result });
                    this.props.onSave();
                }
            );
        }
    }

    public render(): JSX.Element {
        const { emailConfig, emailAddress } = this.state;
        return (
            <div>
                <h2>Email notifications</h2>
                <span>Receive mandatory email alerts and an email summary of unread event notifications </span>
                <br />
                <p>
                    <span className="mr-5">Destination email address: </span>
                    <b>{emailAddress}</b>
                </p>
                <Accordion label="Add additional email recipients" cssWrapper="add-button mb-5" isOpen={false}>
                    <TextBoxEditor
                        disabled={false}
                        label="Additional Email address 1"
                        value={emailConfig?.EmailAddress1}
                        onChange={(v) => {
                            const config = this.state.emailConfig;
                            config.EmailAddress1 = v;
                            this.setState({ emailConfig: config });
                        }}
                        regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                        validationRules={[
                            {
                                errorMessage: "Cannot enter duplicate email addresses",
                                validator: (v) => v != emailAddress && v != emailConfig?.EmailAddress2,
                            },
                        ]}
                    />
                    <TextBoxEditor
                        disabled={false}
                        label="Additional Email address 2"
                        value={emailConfig?.EmailAddress2}
                        onChange={(v) => {
                            const config = this.state.emailConfig;
                            config.EmailAddress2 = v;
                            this.setState({ emailConfig: config });
                        }}
                        regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                        validationRules={[
                            {
                                errorMessage: "Cannot enter duplicate email addresses",
                                validator: (v) => v != emailAddress && v != emailConfig?.EmailAddress1,
                            },
                        ]}
                    />
                </Accordion>
                <div>
                    <span>When do you want to receive an email notification summary?</span>
                    <div className="row pb-7">
                        <div className="col-12 col-sm-fluid col-max-245">
                            <SelectEditor
                                label="Frequency"
                                options={EmailFrequencyOptions}
                                getText={(v) => {
                                    return EmailFrequencyMap[v];
                                }}
                                onChange={(v) => {
                                    const config = this.state.emailConfig;
                                    config.Frequency = v;
                                    this.setState({ emailConfig: config });
                                }}
                                selected={emailConfig?.Frequency}
                                required={"Please select a frequency"}
                                validationRules={[
                                    {
                                        errorMessage: "Please select a frequency",
                                        validator: (v) => {
                                            return v === EmailFrequency.NotSpecified ? false : true;
                                        },
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-12 col-sm-fluid col-max-245">
                    <button
                        className="next-button"
                        onClick={() => {
                            this.onSave();
                        }}
                    >
                        <span className="text">Save email</span>
                    </button>
                </div>
            </div>
        );
    }
}
